import React from "react";
import { X, History as HistoryIcon } from "lucide-react";
import { getHostname } from "../../utils/urlUtils";
import EmptyState from "../common/EmptyState";

function formatTimestamp(iso) {
  try {
    return new Date(iso).toLocaleString(undefined, {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
    });
  } catch {
    return "";
  }
}

function HistoryPanel({ history, onSelect, onDelete, onClearAll }) {
  if (history.length === 0) {
    return <EmptyState icon={HistoryIcon} title="No history yet" description="URLs you preview will show up here." />;
  }

  return (
    <div className="history-panel">
      <div className="panel-actions">
        <button type="button" className="link-btn" onClick={onClearAll}>
          Clear all
        </button>
      </div>
      <ul className="history-list">
        {history.map((item) => (
          <li key={item.url + item.timestamp} className="history-item">
            <button type="button" className="history-item-main" onClick={() => onSelect(item.url)}>
              <span className="history-hostname">{getHostname(item.url)}</span>
              <span className="history-url">{item.url}</span>
              <span className="history-timestamp">{formatTimestamp(item.timestamp)}</span>
            </button>
            <button
              type="button"
              className="icon-btn"
              aria-label={`Remove ${item.url} from history`}
              onClick={() => onDelete(item.url)}
            >
              <X size={14} strokeWidth={1.75} aria-hidden="true" />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default HistoryPanel;
